export default {
  leagues: {
    title: "Select League",
    empty: {
      favoriteLeagues: "Star your favorite leagues to the top for quicker access",
    },
    actions: {
      starFavoriteLeagues: "Star your favorite leagues",
    },
    status: {
      live: "Active",
      offseason: "Offseason",
    },
    sections: {
      myLeagues: "My Leagues",
      sports: {
        baseball: "Baseball",
        basketball: "Basketball",
        football: "Football",
        "australian-football": "Australian Rules Football",
        rugby: "Rugby",
        hockey: "Hockey",
        soccer: "Soccer",
      },
    },
  },
};
